import React from 'react'
import LandingPage from '../../component/Layout/DataTrafficLights/LandingPage'

const DataTrafficLights = () => {
  return (
    <div>
      <LandingPage/>
    </div>
  )
}

export default DataTrafficLights
